// Mobil header-drawer: Markalar submenu acmayi garantile
(function () {
  function bind() {
    document.querySelectorAll('header-drawer summary[on\\:click*="open/submenu"], header-drawer .menu-drawer__menu-item--mainlist').forEach(function (summary) {
      if (summary.dataset.meoksFixed) return;
      summary.dataset.meoksFixed = '1';
      summary.addEventListener('click', function (e) {
        var details = summary.closest('details');
        if (!details) return;
        e.preventDefault();
        e.stopPropagation();
        // Tum kardes details'leri kapat
        var drawer = details.closest('header-drawer') || document;
        drawer.querySelectorAll('details.menu-drawer__menu-container').forEach(function (d) {
          if (d !== details) { d.removeAttribute('open'); d.classList.remove('menu-open'); }
        });
        // Bunu ac
        details.setAttribute('open', '');
        details.classList.add('menu-open');
        var menuDrawer = details.closest('.menu-drawer') || drawer.querySelector('.menu-drawer');
        if (menuDrawer) menuDrawer.classList.add('menu-drawer--has-submenu-opened');
      }, true);
    });
    // Geri butonu
    document.querySelectorAll('header-drawer .menu-drawer__back-button').forEach(function (btn) {
      if (btn.dataset.meoksFixed) return;
      btn.dataset.meoksFixed = '1';
      btn.addEventListener('click', function (e) {
        var details = btn.closest('details');
        if (!details) return;
        e.preventDefault();
        e.stopPropagation();
        details.removeAttribute('open');
        details.classList.remove('menu-open');
        var drawer = btn.closest('header-drawer') || document;
        var menuDrawer = drawer.querySelector('.menu-drawer');
        if (menuDrawer && !drawer.querySelector('details.menu-drawer__menu-container[open]')) {
          menuDrawer.classList.remove('menu-drawer--has-submenu-opened');
        }
      }, true);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bind);
  else bind();
  new MutationObserver(bind).observe(document.body, { childList: true, subtree: true });

  // Geri butonu görünür kalsın — pozisyonu theme'in CSS'i belirlesin, sadece görünürlük zorla
  function applyBackStyle(b) {
    if (b.dataset.meoksStyled) return;
    b.dataset.meoksStyled = '1';
    b.style.setProperty('opacity', '1', 'important');
    b.style.setProperty('visibility', 'visible', 'important');
    b.style.setProperty('pointer-events', 'auto', 'important');
  }
  function styleAll() {
    document.querySelectorAll('header-drawer details[open] .menu-drawer__back-button').forEach(applyBackStyle);
  }
  styleAll();
  new MutationObserver(styleAll).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['open'] });
})();

// Mobil: "(N Değerlendirme)" -> "(N)" kisalt
(function(){
  function trimRating(){
    if (window.innerWidth > 749) return;
    document.querySelectorAll('.meoks-rating-summary__count').forEach(function(el){
      if (el.dataset.meoksTrimmed) return;
      var m = (el.textContent || '').match(/(\d+)/);
      if (m) { el.textContent = '(' + m[1] + ')'; el.dataset.meoksTrimmed = '1'; }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', trimRating);
  else trimRating();
  new MutationObserver(trimRating).observe(document.body, { childList: true, subtree: true });
})();

// PDP mobil: fiyati gorselin hemen altina tasi
(function(){
  function moveBlocks(){
    if (window.innerWidth > 749) return;
    var media = document.querySelector('.product-information__media');
    if (!media) return;
    var grid = media.parentElement;
    if (!grid) return;
    var titleBlock = document.querySelector('.text-block:has(> h1)') || document.querySelector('.product-details .text-block:has(h1)');
    var hasRating = titleBlock && titleBlock.querySelector('.meoks-rating-row');
    if (titleBlock && hasRating && titleBlock.dataset.meoksMoved !== '1') {
      grid.insertBefore(titleBlock, media.nextSibling);
      titleBlock.dataset.meoksMoved = '1';
      titleBlock.classList.add('meoks-title-moved');
    }
    var price = document.querySelector('product-price');
    if (price && price.dataset.meoksMoved !== '1') {
      var anchor = (titleBlock && titleBlock.dataset.meoksMoved === '1') ? titleBlock.nextSibling : media.nextSibling;
      grid.insertBefore(price, anchor);
      price.dataset.meoksMoved = '1';
      price.classList.add('meoks-price-moved');
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', moveBlocks);
  else moveBlocks();
  new MutationObserver(moveBlocks).observe(document.body, { childList: true, subtree: true });
})();

// Arama iconuna donen kategori animasyonu ekle ("Ara: Shorts" stili)
(function(){
  var TERMS = ['Sweatshirt', 'T-shirt', 'Çanta', 'Boxer', 'Ceket', 'Cüzdan', 'Sırt Çantası', 'Yelek', 'Kazak'];
  function buildSearchSpinner(){
    document.querySelectorAll('search-button').forEach(function(sb){
      if (sb.dataset.meoksSpinnerBound === '1') return;
      var btn = sb.querySelector('button');
      if (!btn) return;
      if (btn.querySelector('.meoks-search-spinner')) { sb.dataset.meoksSpinnerBound='1'; return; }
      var wrap = document.createElement('span');
      wrap.className = 'meoks-search-spinner';
      wrap.setAttribute('aria-hidden', 'true');
      wrap.innerHTML = '<span class="meoks-search-spinner__label">Ara:</span>'
        + '<span class="meoks-search-spinner__cycle">'
        + TERMS.map(function(t,i){ return '<span class="meoks-search-spinner__item" style="--idx:'+i+'">'+t+'</span>'; }).join('')
        + '</span>';
      btn.appendChild(wrap);
      sb.dataset.meoksSpinnerBound = '1';
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', buildSearchSpinner);
  else buildSearchSpinner();
  new MutationObserver(buildSearchSpinner).observe(document.body, { childList: true, subtree: true });
})();

// Dil seciciye hover popup ekle
(function(){
  function buildLangPopup(){
    document.querySelectorAll('.language-selector').forEach(function(ls){
      if (ls.dataset.meoksLangBound === '1') return;
      var select = ls.querySelector('.localization-form__select');
      if (!select) return;
      var form = ls.closest('form');
      if (!form) return;
      var popup = document.createElement('div');
      popup.className = 'meoks-lang-popup';
      [].forEach.call(select.options, function(opt){
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.textContent = opt.textContent.trim();
        if (opt.selected) btn.classList.add('is-active');
        btn.addEventListener('click', function(e){
          e.preventDefault();
          select.value = opt.value;
          var ev = new Event('change', { bubbles: true });
          select.dispatchEvent(ev);
          form.submit();
        });
        popup.appendChild(btn);
      });
      ls.appendChild(popup);
      ls.dataset.meoksLangBound = '1';
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', buildLangPopup);
  else buildLangPopup();
  new MutationObserver(buildLangPopup).observe(document.body, { childList: true, subtree: true });
})();

// PDP mobil: H1 basina marka ekle (Jack & Jones JJECORP ... gibi)
(function(){
  function prependBrand(){
    if (window.innerWidth > 749) return;
    var h1 = document.querySelector('.product-details h1, .text-block.meoks-title-moved h1');
    if (!h1 || h1.dataset.meoksBranded === '1') return;
    var vendor = '';
    var vEl = document.querySelector('.meoks-vendor-name');
    if (vEl) vendor = vEl.textContent.trim();
    if (!vendor) {
      var sim = document.querySelector('[data-vendor]');
      if (sim) vendor = sim.getAttribute('data-vendor').trim();
    }
    if (!vendor) return;
    var title = h1.textContent.trim();
    if (title.toLowerCase().indexOf(vendor.toLowerCase()) === 0) { h1.dataset.meoksBranded = '1'; return; }
    var safe = vendor.replace(/[&<>"']/g, function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]; });
    h1.innerHTML = '<strong class="meoks-h1-brand">' + safe + '</strong> ' + h1.innerHTML;
    h1.dataset.meoksBranded = '1';
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', prependBrand);
  else prependBrand();
  new MutationObserver(prependBrand).observe(document.body, { childList: true, subtree: true });
})();

// Fiyat formati: en-US -> TR (1,139.99TL -> 1.139,99 TL)
(function(){
  function fmtTR(text){
    // "1,139.99TL" veya "699.99TL" yakala
    return text.replace(/(\d{1,3}(?:,\d{3})*)\.(\d{2})\s*TL/g, function(_, intPart, dec){
      var tr = intPart.replace(/,/g, '.');
      return tr + ',' + dec + ' TL';
    });
  }
  function trPrices(){
    document.querySelectorAll('.price, .price-item--sale, .price-item--regular, .compare-at-price').forEach(function(el){
      var orig = el.dataset.meoksOrig || el.textContent;
      var next = fmtTR(orig);
      if (next !== el.textContent) {
        el.dataset.meoksOrig = orig;
        el.textContent = next;
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', trPrices);
  else trPrices();
  new MutationObserver(trPrices).observe(document.body, { childList: true, subtree: true, characterData: true });
})();

// Mobilde footer kolonlarini accordion'a cevir
(function(){
  function buildFooterAccordion(){
    if (window.innerWidth > 749) return;
    document.querySelectorAll('.meoks-fcol').forEach(function(col){
      if (col.dataset.meoksAcc === '1') return;
      var title = col.querySelector('.meoks-fcol__title');
      if (!title) { col.dataset.meoksAcc = '1'; return; }
      col.classList.add('meoks-fcol--collapsed');
      title.setAttribute('role', 'button');
      title.setAttribute('aria-expanded', 'false');
      title.setAttribute('tabindex', '0');
      title.classList.add('meoks-fcol__title--toggle');
      var caret = document.createElement('span');
      caret.className = 'meoks-fcol__caret';
      caret.innerHTML = '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="6 9 12 15 18 9"></polyline></svg>';
      title.appendChild(caret);
      function toggle(){
        var open = col.classList.toggle('meoks-fcol--open');
        col.classList.toggle('meoks-fcol--collapsed', !open);
        title.setAttribute('aria-expanded', open ? 'true' : 'false');
      }
      title.addEventListener('click', toggle);
      title.addEventListener('keydown', function(e){ if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle(); } });
      col.dataset.meoksAcc = '1';
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', buildFooterAccordion);
  else buildFooterAccordion();
  new MutationObserver(buildFooterAccordion).observe(document.body, { childList: true, subtree: true });
})();

// Urun Aciklamasi: uzunsa "Daha fazlasi" toggle
(function(){
  var COLLAPSED_PX = 260;
  function bindShowMore(){
    var els = document.querySelectorAll('.meoks-pd-inline__content:not([data-meoks-more-bound])');
    if (!els.length) return;
    // Batch reads inside rAF to avoid forced reflow
    requestAnimationFrame(function(){
    els.forEach(function(el){
      if (el.dataset.meoksMoreBound === '1') return;
      var natural = el.scrollHeight;
      if (natural <= COLLAPSED_PX + 40) { el.dataset.meoksMoreBound = '1'; return; }
      el.classList.add('meoks-pd-inline__content--collapsed');
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'meoks-pd-inline__more';
      btn.setAttribute('aria-expanded', 'false');
      var _misc = (window.MeoksI18n && window.MeoksI18n.misc) || {};
      btn.innerHTML = '<span>' + (_misc.showMore || 'Daha fazlasını göster') + '</span><svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="6 9 12 15 18 9"></polyline></svg>';
      btn.addEventListener('click', function(){
        var open = el.classList.toggle('meoks-pd-inline__content--expanded');
        el.classList.toggle('meoks-pd-inline__content--collapsed', !open);
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        var _misc2 = (window.MeoksI18n && window.MeoksI18n.misc) || {};
        btn.querySelector('span').textContent = open ? (_misc2.showLess || 'Daha az göster') : (_misc2.showMore || 'Daha fazlasını göster');
        btn.classList.toggle('meoks-pd-inline__more--open', open);
      });
      el.insertAdjacentElement('afterend', btn);
      el.dataset.meoksMoreBound = '1';
    });
    });
  }
  var _debounce;
  function debouncedBind(){
    clearTimeout(_debounce);
    _debounce = setTimeout(bindShowMore, 250);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bindShowMore);
  else bindShowMore();
  new MutationObserver(debouncedBind).observe(document.body, { childList: true, subtree: true });
})();

// Beden butonlarini dogal sirada (XS<S<M<L<XL<2XL<3XL<4XL) ya da numerik sirada diz
(function(){
  var sizeRank = {'XXS':-2,'XS':-1,'S':0,'M':1,'L':2,'XL':3,'XXL':4,'2XL':4,'XXXL':5,'3XL':5,'4XL':6,'5XL':7,'6XL':8};
  function sortSizes(){
    document.querySelectorAll('fieldset.variant-option').forEach(function(fs){
      if (fs.dataset.meoksSorted === '1') return;
      var labels = Array.from(fs.querySelectorAll(':scope > label.variant-option__button-label'));
      if (labels.length < 2) return;
      var values = labels.map(function(l){ var i=l.querySelector('input'); return i ? i.value : ''; });
      var allKnownSize = values.every(function(v){ return v in sizeRank; });
      var allNumeric = values.every(function(v){ return /^\d+(\.\d+)?$/.test(v); });
      if (!allKnownSize && !allNumeric) { fs.dataset.meoksSorted = '1'; return; }
      labels.sort(function(a,b){
        var va = a.querySelector('input').value, vb = b.querySelector('input').value;
        if (allKnownSize) return sizeRank[va] - sizeRank[vb];
        return parseFloat(va) - parseFloat(vb);
      });
      labels.forEach(function(l){ fs.appendChild(l); });
      fs.dataset.meoksSorted = '1';
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sortSizes);
  else sortSizes();
  new MutationObserver(sortSizes).observe(document.body, { childList: true, subtree: true });
})();

// Zoom dialog mobil: thumbnail tiklayinca gallery'i o gorsele scroll et + thumb aktif border
(function(){
  function bindThumbScroll(){
    if (window.innerWidth > 749) return;
    var dlg = document.querySelector('.dialog-zoomed-gallery__dialog');
    if (!dlg || dlg.dataset.meoksThumbBound === '1') return;
    var gallery = dlg.querySelector('.dialog-zoomed-gallery');
    var thumbs = dlg.querySelector('.dialog-thumbnails-list');
    if (!gallery || !thumbs) return;
    var thumbBtns = thumbs.querySelectorAll('button');
    var slides = gallery.querySelectorAll(':scope > li');
    if (!thumbBtns.length || !slides.length) return;
    thumbBtns.forEach(function(btn, idx){
      btn.addEventListener('click', function(){
        var slide = slides[idx];
        if (slide) slide.scrollIntoView({behavior:'smooth', block:'start'});
        thumbBtns.forEach(function(b){ b.classList.remove('is-active'); b.removeAttribute('aria-selected'); });
        btn.classList.add('is-active');
        btn.setAttribute('aria-selected','true');
      }, true);
    });
    dlg.dataset.meoksThumbBound = '1';
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bindThumbScroll);
  else bindThumbScroll();
  new MutationObserver(bindThumbScroll).observe(document.body, { childList: true, subtree: true });
})();

// PDP mobil: slideshow dot indicator -> her zaman 3 nokta (windowed)
(function(){
  function windowDots(){
    if (window.innerWidth > 749) return;
    document.querySelectorAll('.slideshow-controls__dots').forEach(function(ol){
      var items = Array.from(ol.children).filter(function(li){ return li.tagName === 'LI'; });
      if (items.length <= 3) { items.forEach(function(li){ li.style.display = ''; }); return; }
      var activeIdx = items.findIndex(function(li){ var b = li.querySelector('button'); return b && b.getAttribute('aria-selected') === 'true'; });
      if (activeIdx < 0) activeIdx = 0;
      var start = Math.max(0, Math.min(activeIdx - 1, items.length - 3));
      var end = start + 3;
      items.forEach(function(li, i){
        li.style.display = (i >= start && i < end) ? '' : 'none';
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', windowDots);
  else windowDots();
  new MutationObserver(windowDots).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['aria-selected'] });
})();
